import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ApolloProvider } from '@apollo/client';
import { ConnectedRouter } from 'connected-react-router';

import { configureStore, history } from './store';
import Login from 'pages/Login';
import App from 'App';
import apolloClient from 'apolloClient';
import './utils/sentry.ts';

const store = configureStore();

function Root() {
  return (
    <Provider store={store}>
      <ApolloProvider client={apolloClient}>
        <ConnectedRouter history={history}>
          <Switch>
            <Route path="/login">
              <Login />
            </Route>
            <Route path="/">
              <App />
            </Route>
          </Switch>
        </ConnectedRouter>
      </ApolloProvider>
    </Provider>
  );
}

export default Root;
